import React from 'react'
import { Table } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import '../styles/captable.scss'
import { useIntl } from 'react-intl'

export const CaptableSkeleton = () => {
    const { formatMessage } = useIntl()
    return (
        <>
            <div className='bg-white rounded-top p-4' style={{ overflowX: 'auto' }}>
                <Table className='w-100' style={{ minWidth: '600px' }}>
                    <thead className='custom-thead border-bottom'>
                        <tr className='font-size-12 font-weight-400 table-row border-dark-mode'>
                            <th className='min-w-120px pb-6 pt-4'>
                                <div>{formatMessage({ id: 'Shareholdings' })}</div>
                            </th>
                            <th className='min-w-120px pb-6 pt-4'>
                                <div>{formatMessage({ id: 'Transactions' })}</div>
                            </th>
                            <th className='min-w-120px pb-6 pt-4'>
                                <div>{formatMessage({ id: 'Security Classes' })}</div>
                            </th>
                            <th className='min-w-120px pb-6 pt-4'>
                                <div>{formatMessage({ id: 'Fully Diluted Shares' })}</div>
                            </th>
                            <th className='min-w-120px pb-6 pt-4'>
                                <div>{formatMessage({ id: 'Amount Invested' })}</div>
                            </th>
                            <th className='min-w-120px pb-6 pt-4'>
                                <div>{formatMessage({ id: 'Ownership' })}</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan={6}>
                                <Skeleton
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    height={40}
                                    count={6} />
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
            <div
                className='d-flex justify-content-between mb-4 rounded-bottom'
                style={{
                    background: '#4776E624',
                    overflowX: 'auto',
                }}
            >
                <div className='px-5 min-w-120px pb-6 pt-4'>
                    <Skeleton
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        width={100}
                        height={20}
                    />
                </div>
                <div className='px-5 min-w-120px pb-6 pt-4'>
                    <div className='d-flex gap-2'>
                        <Skeleton
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            width={20}
                            height={20}
                        />
                        <Skeleton
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            width={100}
                            height={20}
                        />
                    </div>
                </div>
                <div className='px-5 min-w-120px pb-6 pt-4'></div>
                <div className='px-5 min-w-120px pb-6 pt-4'>
                    <Skeleton
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        width={100}
                        height={20}
                    />
                </div>
                <div className='px-5 min-w-120px pb-6 pt-4'>
                    <Skeleton
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        width={100}
                        height={20}
                    />
                </div>
                <div className='px-5 min-w-120px pb-6 pt-4'>
                    <Skeleton
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        width={100}
                        height={20}
                    />
                </div>
                <div className='px-5 min-w-120px pb-6 pt-4'></div>
            </div>
        </>
    )
}
